export var PerformanceSettings;
(function (PerformanceSettings) {
    PerformanceSettings["USD_VALUE"] = "USD value";
    PerformanceSettings["ASSET_ACCUMULATION"] = "Asset accumulation";
})(PerformanceSettings || (PerformanceSettings = {}));
